
/* 图片自响应 */
export function resetImgSizeWH(img, nw, nh, w, h) {
    var nwh = nw / nh;
    var wh = w / h;
    if (nwh > wh) {
        img.height = h;
        var width = parseInt(nwh * h);
        img.style.width = width + 'px';
        var left = parseInt((width - w) / 2) * -1;
        img.style.marginLeft = left + "px";
    } else if (nwh < wh) {
        img.style.width = w + 'px';
        var height = parseInt(1 / nwh * w);
        img.height = height;
        var top = parseInt((height - h) / 2) * -1;
        // img.style.marginTop = top + "px";
    } else {
        img.height = h;
        img.style.width = w + 'px';
    }
}

//判断手机还是pc,pc返回true
export function pcBrowser() {
    var sUserAgent = navigator.userAgent.toLowerCase();
    var bIsIpad = sUserAgent.match(/ipad/i) == "ipad";
    var bIsIphoneOs = sUserAgent.match(/iphone os/i) == "iphone os";
    var bIsMidp = sUserAgent.match(/midp/i) == "midp";
    var bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) == "rv:1.2.3.4";
    var bIsUc = sUserAgent.match(/ucweb/i) == "ucweb";
    var bIsAndroid = sUserAgent.match(/android/i) == "android";
    var bIsCE = sUserAgent.match(/windows ce/i) == "windows ce";
    var bIsWM = sUserAgent.match(/windows mobile/i) == "windows mobile";
    if (!(bIsIpad || bIsIphoneOs || bIsMidp || bIsUc7 || bIsUc || bIsAndroid || bIsCE || bIsWM)) {
        return true;
    }
    else{
        return false;
    }
}


// WEBPACK FOOTER //
// ./src/axios/utils.js